import { all, takeEvery, takeLatest, put } from 'redux-saga/effects'
import { notification } from 'antd'
import { request } from '../../../../admincore'

import { addPerson } from '../../api'
import actions from './actions'

// const getCompanySelect = state => state.companySelect

function* CREATE({ payload: { params } }) {
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(addPerson(companySelect, params), actions.CREATE))
}

function* SUCCESS({ intl }) {
  yield notification.success({
    message: intl.formatMessage({ id: 'common.notifications.done' }),
    description: intl.formatMessage({ id: 'people.notifications.added' }),
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.CREATE, CREATE), takeLatest(actions.CREATE_SUCCESS, SUCCESS)])
}
